import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Button, PopupContentContainer, RecordingsIcon, ReportIcon, } from '@streamr/tv-ui';
import { executeSoon } from '@streamr/tv-utils';
import { useNavigate } from 'react-router';
import styled from 'styled-components';
import { COMPLAINT_REPORT_URL } from '../../consts';
import { Popup, TopCenter } from '../../utils/popups';
import { formBroadcastPath } from '../../utils/url';
import { AbstractPopup, DismissalReason, } from './AbstractPopup';
import { ScrollablePopupContainer } from './helpers/ScrollablePopupContainer';
import { PopupCssPreset } from './Popup.styles';
function ViewerOptionsPopup({ resolve, activeBroadcast, variant, ...props }) {
    const navigate = useNavigate();
    return (_jsx(ViewerOptionsPopupRoot, { translateFn: TopCenter, ...props, className: variant, children: _jsx(ScrollablePopupContainer, { fullscreenOnly: variant === 'mobile', onCloseButtonClick: () => {
                props.reject(DismissalReason.CloseButton);
            }, children: _jsxs(ButtonsContainer, { children: [_jsx(StyledButton, { type: "button", onClick: () => {
                            resolve();
                            navigate(formBroadcastPath(activeBroadcast, '/recordings'));
                        }, children: _jsxs(StyledPopupContentContainer, { children: [_jsx("span", { children: "View broadcast recordings" }), _jsx(RecordingsIcon, { size: "x1_25" })] }) }), _jsx(StyledButton, { type: "button", onClick: () => {
                            resolve();
                            window.open(COMPLAINT_REPORT_URL, '_blank');
                        }, children: _jsxs(StyledPopupContentContainer, { children: [_jsx("span", { children: "Report" }), _jsx(ReportIcon, {})] }) })] }) }) }));
}
const ViewerOptionsPopupRoot = styled(AbstractPopup) `
    ${PopupCssPreset.Fullscreen};

    &.desktop {
        --Popup_Padding: 0;
        --Popup_BorderRadius: 1rem;

        @media (min-width: 30rem) {
            ${PopupCssPreset.AnchoredTopCenter};
            --Popup_Padding: 1rem 0;
            --Popup_Width: 20.75rem;
        }
    }
`;
const ButtonsContainer = styled.div `
    display: flex;
    flex-direction: column;
    gap: 1rem;
`;
const StyledButton = styled(Button) `
    --Button_HoverTransform: 0;
    --Button_ActiveTransform: 0;
    width: 100%;
`;
const StyledPopupContentContainer = styled(PopupContentContainer) `
    display: flex;
    width: 100%;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    gap: 0.5rem;
    white-space: normal;
    text-align: left;
`;
const viewerOptionsPopup = Popup.create(ViewerOptionsPopup);
export function openViewerOptions(options) {
    executeSoon(async () => {
        options.onOpenPopup?.();
        try {
            await viewerOptionsPopup.pop({
                anchorRef: options.anchorRef,
                activeBroadcast: options.activeBroadcast,
                variant: options.variant,
            });
        }
        catch (_ignore) {
        }
        finally {
            options.onClosePopup?.();
        }
    });
}
